export default __webpack_public_path__ + "static/media/cx_cover_c50.843d994c.jpg";